/**
 * Attendance components: the lecturer check/edit modal (checkbox list,
 * date picker, "mark all present", unticked-on-top sorting) and the
 * student view-only report modal (week/month toggle).
 */

function todayIso() {
  const date = new Date();
  const pad = (value) => String(value).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

function sortUntickedOnTop(container) {
  const rows = Array.from(container.querySelectorAll('.attendance-student-row'));
  rows.sort((a, b) => {
    const aChecked = a.querySelector('.attendance-student-check').checked;
    const bChecked = b.querySelector('.attendance-student-check').checked;
    return aChecked === bChecked ? 0 : aChecked ? 1 : -1;
  });
  rows.forEach((row) => container.appendChild(row));
}

function initCheckModal(rootEl) {
  const modalEl = rootEl.querySelector('#attendanceCheckModal');
  if (!modalEl) {
    return;
  }

  const dateInput = modalEl.querySelector('[data-cy="attendance-date-input"]');
  const container = modalEl.querySelector('#attendance-students-list');
  const markAll = modalEl.querySelector('#attendance-mark-all');
  if (!dateInput || !container) {
    return;
  }

  const setChecked = (uuids) => {
    const presentSet = new Set(uuids);
    const checks = container.querySelectorAll('.attendance-student-check');
    checks.forEach((checkbox) => {
      checkbox.checked = presentSet.has(checkbox.value);
    });
    if (markAll) {
      markAll.checked = checks.length > 0 && presentSet.size === checks.length;
    }
    sortUntickedOnTop(container);
  };

  markAll?.addEventListener('change', () => {
    container.querySelectorAll('.attendance-student-check').forEach((checkbox) => {
      checkbox.checked = markAll.checked;
    });
    sortUntickedOnTop(container);
  });

  rootEl.querySelectorAll('[data-cy="attendance-check-button"]').forEach((button) => {
    button.addEventListener('click', () => {
      dateInput.value = todayIso();
      setChecked([]);
    });
  });

  rootEl.querySelectorAll('[data-cy="attendance-edit-button"]').forEach((button) => {
    // Prepare the modal before Bootstrap opens it (this element handler runs
    // before Bootstrap's delegated data-api listener on document).
    button.addEventListener('click', () => {
      dateInput.value = button.dataset.date || todayIso();
      const uuids = (button.dataset.present || '').split(',').filter(Boolean);
      setChecked(uuids);
    });
  });
}

function initReportModal(rootEl) {
  const modalEl = rootEl.querySelector('#attendanceReportModal');
  if (!modalEl) {
    return;
  }

  const toggles = modalEl.querySelectorAll(
    '[data-cy="attendance-report-period-toggle"]',
  );
  const panels = modalEl.querySelectorAll('[data-cy="attendance-report-panel"]');

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const range = toggle.dataset.range;
      toggles.forEach((t) => t.classList.toggle('active', t === toggle));
      panels.forEach((panel) => {
        panel.classList.toggle('d-none', panel.dataset.range !== range);
      });
    });
  });
}

export function init(rootEl = document) {
  initCheckModal(rootEl);
  initReportModal(rootEl);
}
